// This must be the first line for IE9 and above support
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'modules/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initDatadog } from 'loggers/datadog';

initDatadog();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.register();
